<template>
	<div>
		<h1>Exhibition closed</h1>
		<p>The exhibition area will be opened once the meeting has started.</p>
		<div class="buttons">
			<a class="button is-primary" @click="cancel()">OK</a>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ExhibitionOff',
		data() {
			return {};
		},
		methods: {
			cancel() {
				this.$emit('close');
			},
		},
	};
</script>
